import styled from 'styled-components';

const Label = styled.label`
  display: block;
  margin-bottom: 3px;
  font-weight: 600;
  opacity: 0.6;
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label.js